import { px2Rem } from "../../../themes/Mixins"
import Description from "../../common/Description"

export const MainContent = Description.extend`
  font-size: ${px2Rem(16)};
  padding: 0 16%;

  @media (min-width: 768px) {
    margin-bottom: ${px2Rem(50)};
    font-size: ${px2Rem(24)};
    padding: 0 7%;
  }
`

export const Author = Description.extend`
  padding: 0 16%;
  font-size: ${px2Rem(11)};

  @media (min-width: 768px) {
    padding: 0 7%;
    font-size: ${px2Rem(17)};
  }
`



// WEBPACK FOOTER //
// ./src/components/sections/testimonial/SlideResponsive.js